// src/components/Admin/PostManager/ReportManager.jsx
import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Tabs, Tab, Paper,
} from '@mui/material';

import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import CampaignIcon from '@mui/icons-material/Campaign';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';

import api from '../../../api/axios';
import ReportTable from './ReportTable';
import ReportLogTable from './ReportLogTable';

export default function ReportManager() {
  const [tab, setTab] = useState(0);
  const handleTabChange = (_, v) => setTab(v);

  const [reports, setReports] = useState([]);

  /* 신고 목록 불러오기 */
  const loadReports = () => {
    api.get('/api/reports/grouped/')
      .then((res) => setReports(res.data))
      .catch((err) => console.error('신고 목록 조회 실패:', err));
  };

  /* 신고 처리 */
  const handleProcess = (id, action) => {
    api.post(`/api/reports/${id}/process/`, { action })
      .then(() => {
        alert('처리 완료!');
        loadReports();
      })
      .catch(() => alert('처리 실패'));
  };

  /* 목록 탭일 때만 로드 */
  useEffect(() => {
    if (tab === 0) loadReports();
  }, [tab]);

  return (
    <Box
      sx={{
        p: 4,
        /* 모바일: 90 % 축소 & 좌상단 기준 */
        '@media (max-width:600px)': {
          transform: 'scale(0.9)',
          transformOrigin: 'top left',
          p: 2,
        },
      }}
    >
      {/* 타이틀 */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <ReportProblemIcon sx={{ fontSize: '2rem' }} />
        <Typography
          variant="h4"
          sx={{
            fontWeight: 'bold',
            '@media (max-width:600px)': { fontSize: '1.5rem' },
          }}
        >
          신고 관리
        </Typography>
      </Box>

      {/* 본탭 */}
      <Paper
        elevation={2}
        sx={{
          mb: 3,
          borderRadius: 2,
          backgroundColor: '#f5f5f5',
          px: 2,
          '@media (max-width:600px)': { px: 1 },
        }}
      >
        <Tabs
          value={tab}
          onChange={handleTabChange}
          textColor="primary"
          indicatorColor="primary"
          variant="fullWidth"
          sx={{
            '& .MuiTab-root': {
              minHeight: 48,
              '@media (max-width:600px)': { minHeight: 40, fontSize: '0.8rem' },
            },
          }}
        >
          <Tab icon={<CampaignIcon />} iconPosition="start" label="신고 목록" />
          <Tab icon={<ManageSearchIcon />} iconPosition="start" label="신고 처리 로그" />
        </Tabs>
      </Paper>

      {/* 콘텐츠 */}
      {tab === 0 && (
        <ReportTable
          reports={reports}
          onProcess={handleProcess}
        />
      )}
      {tab === 1 && <ReportLogTable />}
    </Box>
  );
}
